'use strict';

var y = require('yup');
var utils = require('../utils.js');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'sui';
const SUI_ERROR = 'sui';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? SUI_ERROR
        },
        test: (value)=>{
            // Taken from SUI SDK
            // https://github.com/MystenLabs/sui/blob/3db05b0e144fb242bb696ab943dc688a5f1c7966/sdk/typescript/src/utils/sui-types.ts#L25
            return utils.isHex(value) && utils.getHexByteLength(value) === 32;
        }
    });
});

exports.SUI_ERROR = SUI_ERROR;
//# sourceMappingURL=sui.js.map
